import { render } from "./Urbanism-and-development.vue?vue&type=template&id=73f25799&scoped=true"
import script from "./Urbanism-and-development.vue?vue&type=script&lang=js"
export * from "./Urbanism-and-development.vue?vue&type=script&lang=js"

import "./Urbanism-and-development.vue?vue&type=style&index=0&id=73f25799&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f25799"]])

export default __exports__